/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Maëlle MONTINERI
 * @date        25/10/2019 14:58
 * @copyright   Copyright (c) 2002-2019 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import L from 'leaflet';

export class blocMap {
    constructor()
    {
        this.initializeBlocMap();
    }
    
    initializeBlocMap() {
        if ( $('.wp-block-map').length > 0 )
        {
            let markers       = [];
            let initPositions = [];
            let positions     = [];
            let $markers      = $('#map').find('.marker');
        
            // create map
            let map = L.map('map').setView([ 0, 0 ], 5);
        
            L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
            {
                attribution: 'données © <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - rendu <a href="//openstreetmap.fr">OSM France</a>',
                minZoom: 1,
                maxZoom: 20
            }).addTo(map);
    
            let markerIcon = L.icon({
                iconUrl: Theme.themeURL + '/assets/dist/images/markers/marker.svg',
                iconSize: [ 24, 40 ],
                iconAnchor:   [10, 15], // point of the icon which will correspond to marker's location
                popupAnchor:  [0, -15]  // point from which the popup should open relative to the iconAnchor
            });
        
            // add markers
            $markers.each(function ()
              {
                  var marker = L.marker([ $(this).data('lat'), $(this).data('lng') ], {icon: markerIcon}).addTo(map);
                  marker.bindPopup($(this).html()).openPopup();
                  marker.bindPopup($(this).html()).closePopup();
                  markers.push(marker);
                  positions.push([ $(this).data('lat'), $(this).data('lng') ]);
                  initPositions.push([ $(this).data('lat'), $(this).data('lng') ]);
              });
    
            let group = L.featureGroup(markers); //add markers array to featureGroup
        
            // Marker center on map
            map.fitBounds(group.getBounds());
        
            // KML
            let kml = $("#map-kml").attr('data-kml');
            let customLayer = L.geoJson(null, {
                style: function(feature) {
                    return { color: '#171717' };
                }
            });
            let runLayer = omnivore.kml(kml, null, customLayer).addTo(map);
        
            // Disable zoom on map on scroll
            map.scrollWheelZoom.disable();
        
            return map;
        }
    }
}